//imports
import React, { useState, useEffect } from "react";
import {
  Box,
  Link,
  Breadcrumbs,
  Stack,
  Button,
  Grid,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  MenuItem,
  Checkbox,
  InputLabel,
  Select,
} from "@mui/material";
import { externalgetApi } from "../../services/external/externalApis";
import { ORDER_API_04 } from "../../api/ApiModel";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
function ManageOrder() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [additionalData, setAdditionalData] = useState(null);
  const location = useLocation();
  const { ORDERCODE } = location.state || {};

  const gotToView = () => {
    navigate("/orderlist");
  };

  useEffect(() => {
    fetchOrderData();
  }, [ORDERCODE]);

  const fetchOrderData = async () => {
    setIsLoading(true);
    try {
      const orderResult = await externalgetApi(ORDER_API_04, "get", {
        ORDERCODE,
      });
      console.log("API response:", orderResult);

      // Set order data from "set[1]"
      const filteredData = Object.values(orderResult["1"])
        .flat()
        .filter((item) => item && item.MENUNAME);
      setOrderData(filteredData);

      // Set additional data from "set[2]"
      const additional = orderResult["2"];
      setAdditionalData(additional);
    } catch (err) {
      console.error("Error fetching order data:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const getRemarkText = (idNo) => {
    const matchingRemarks = additionalData
      ? additionalData.filter((item) => item.ORDERITEMCODE === idNo)
      : [];

    // Join all remarks for the matched items
    return matchingRemarks.length > 0
      ? matchingRemarks.map((item) => item.REMARK).join("; ")
      : "No Remark";
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" href="/">
                  Home
                </Link>
                <Link underline="none">Setting</Link>
                <Link underline="none">Order return</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.AddStyledBox}>
        <Toolbar
          sx={{
            maxWidth: "100%",
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: { xs: "170px", md: "155px" },
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ color: theme.palette.text.primary, flex: "1 1 100%", ml: 1 }}
          >
            Order Number: {ORDERCODE}
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="flex-end" p={2}>
            <Button
              variant="contained"
              // onClick={handleOpenDialog}
              sx={{
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
                textTransform: "capitalize",
                width: "180px",
              }}
            >
              Return / refund order
            </Button>
          </Stack>
        </Toolbar>

        {isLoading ? (
          <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
        ) : (
          <TableContainer component={Paper} sx={styles.VI_ViewStyledPaper}>
            <Table sx={{ minWidth: 650 }} aria-label="order table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Menu Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Quantity
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">
                    Rate
                  </TableCell>

                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Remark
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderData.map((orderItem) => (
                  <TableRow>
                    <TableCell>{orderItem.MENUNAME}</TableCell>
                    <TableCell align="center">{orderItem.QTY}</TableCell>
                    <TableCell align="right">{orderItem.RATE}</TableCell>

                    <TableCell align="center">
                      {getRemarkText(orderItem.IDNO)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  );
}

export default ManageOrder;
